import { Breadcrumbs as MBreadcrumbs, Flex } from '@mantine/core';
import { useBreadcrumbs } from '@shared/lib';

export const Breadcrumbs = () => {
  const context = useBreadcrumbs();
  const breadcrumb = context?.breadcrumb;

  if (!breadcrumb) {
    return null;
  }

  return (
    <Flex py={16} maw={1512} mx='auto' w='100%' px={{ base: 16, md: 0 }}>
      <MBreadcrumbs>{breadcrumb}</MBreadcrumbs>
    </Flex>
  );
};
